import { LoadIdView, WaybillIdView } from '../../../../../models';
import {
  ShipmentAlert,
  ShipmentArrivalDatesModel,
  PickUpDeliveryInfo,
  DemurrageDetentionStatusEnum,
  ShipmentQuickFilterModel,
} from '../../../models/shipment-common-models';
import { ListServerPaginationStateModel } from '../../../../../../common';
import { MonitoringContentType } from '../../../../../constants';

export interface DemurrageDetentionModel {
  status: DemurrageDetentionStatusEnum;
  days: number;
  remainingDays: number;
}

export type DemurrageDetentionStatisticFiltersModel = {
  containerCharges: ShipmentQuickFilterModel[];
};

export interface DemurrageDetentionContainerModel {
  container: string;
  originDetention: DemurrageDetentionModel;
  originDemurrage: DemurrageDetentionModel;
  destinationDetention: DemurrageDetentionModel;
  destinationDemurrage: DemurrageDetentionModel;
  summaryCost: string[];
  lastStatus: string;
}

export class DemurrageDetentionShipmentModel {
  idView: LoadIdView | WaybillIdView | null = null;
  reference: string | null = null;
  pickUp: PickUpDeliveryInfo | null = null;
  delivery: PickUpDeliveryInfo | null = null;
  arrivalDates: ShipmentArrivalDatesModel | null = null;
  alert: {
    active: boolean;
    events: ShipmentAlert[];
  } | null = null;
  containers: DemurrageDetentionContainerModel[] = [];
  type: MonitoringContentType | null = null;
}

export type DemurrageDetentionListDto = Omit<ListServerPaginationStateModel<DemurrageDetentionShipmentModel>, 'loaded'>;
